import { Trans } from '@lingui/react/macro';

import ContactDetails from '@/components/ContactDetails';
import Stack from '@/design_system/Stack';
import { ArticleWithRelations } from '@/models/request';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

import { DownloadOrganizationQuoteButton } from '../ArticleActions/shared/RecordClientContactDialog';

import { BaseMessage, BaseMessageDetailedContent } from './BaseMessage';

export const ContactClientTaskMessage = ({ article }: { article: ArticleWithRelations }) => {
  const { request, workflow } = useRequestContext();

  if (!request.client) {
    return null;
  }

  const showContactDetails =
    !!request.client.name || !!request.client.email || !!request.client.phone;
  const showOrganizationQuoteButton =
    !!workflow?.config.organizationQuote?.enabled && article.step?.step === 'validation';

  return (
    <BaseMessage
      title={<Trans id="article.task.contact-client.title">Reach out to the client</Trans>}
      message={
        <Stack gap="0.25rem">
          <p>
            {article.step?.step === 'validation' ? (
              <Trans id="article.task.contact-client.message.validation">
                The quote requires the client's approval before it can be validated. Please reach
                out to them and record your exchange.
              </Trans>
            ) : article.step?.step === 'transit' ? (
              <Trans id="article.task.contact-client.message.pick-up">
                The package is at the store and the client must now come pick it up. Please reach
                out to them and record your exchange.
              </Trans>
            ) : (
              <Trans id="article.task.contact-client.message">
                Please reach out to the client and record your exchange.
              </Trans>
            )}
          </p>

          {(showContactDetails || showOrganizationQuoteButton) && (
            <Stack gap="0.5rem">
              {showContactDetails && (
                <BaseMessageDetailedContent article={article}>
                  <ContactDetails
                    type="client"
                    name={request.client.name}
                    email={request.client.email}
                    phone={request.client.phone}
                    size="medium"
                  />
                </BaseMessageDetailedContent>
              )}

              {showOrganizationQuoteButton && <DownloadOrganizationQuoteButton />}
            </Stack>
          )}
        </Stack>
      }
      article={article}
    />
  );
};
